import { Injectable } from '@angular/core';

import { EventOptionGroup, EventOptionGroupType } from '@frontend/sports/betting-offer/feature/model';
import { StringDictionary } from '@frontend/sports/common/core/utils/extended-types';

export interface ITabIndex {
    lastActiveTabId: string;
    lastActiveTabIndex: number;
}

export const createDefaultTabIndex = (): ITabIndex => ({ lastActiveTabId: '', lastActiveTabIndex: -1 });

@Injectable({ providedIn: 'root' })
export class OptionGroupTabindexKeeperService {
    private tabIndexes: ITabIndex[] = [];
    private marketIdMapping: StringDictionary<number> = {};

    getTabIndexByGroup(optionGroup: EventOptionGroup): ITabIndex {
        if (!optionGroup.hasSubGroups(EventOptionGroupType.Period)) {
            return createDefaultTabIndex();
        }

        const marketIds = optionGroup
            .getSubGroups(EventOptionGroupType.Period)
            .map((group) => `${group.detailedGrouping.marketSet}-${group.detailedGrouping.marketOrder}-${group.id}`);
        const groupId = marketIds.find((value) => this.marketIdMapping[value] !== undefined);

        const tabIndex = this.getOrCreateTabIndex(groupId);
        marketIds.forEach((value) => {
            this.marketIdMapping[value] = tabIndex;
        });

        return this.tabIndexes[tabIndex];
    }

    private getOrCreateTabIndex(groupId: string | undefined): number {
        if (groupId) {
            return this.marketIdMapping[groupId];
        }

        this.tabIndexes.push(createDefaultTabIndex());

        return this.tabIndexes.length - 1;
    }
}
